import { TaskFetchStatus } from '~/modules/tasks/taskModels.ts';
import type { TTasksRequestState, TTasksThunkError } from '../types.ts';

export const setTasksPendingAction = <T>(slice: TTasksRequestState<T>) => {
  slice.status = TaskFetchStatus.Loading;
  slice.error = null;
};

export const setTasksFulfilledAction = <T>(slice: TTasksRequestState<T>, data: T) => {
  slice.status = TaskFetchStatus.Success;
  slice.data = data;
  slice.error = null;
};

export const setTasksRejectedAction = <T>(slice: TTasksRequestState<T>, error: unknown) => {
  slice.status = TaskFetchStatus.Error;
  slice.error = (error as TTasksThunkError) ?? { message: 'Request failed' };
};
